define.alias("ember-in-viewport/initializers/viewport-config", "auth/initializers/viewport-config");